import { render } from "./UserEditHistoryModal.vue?vue&type=template&id=7c549151"
import script from "./UserEditHistoryModal.vue?vue&type=script&lang=js"
export * from "./UserEditHistoryModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__